/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
var Icon_1 = require("./Icon");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./IconButton.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-iconButton");
exports.IconButton = function IconButton(_a) {
    var _b = _a.TagName, TagName = _b === void 0 ? "a" : _b, type = _a.type, className = _a.className, innerRef = _a.innerRef, props = tslib_1.__rest(_a, ["TagName", "type", "className", "innerRef"]);
    return React.createElement(TagName, tslib_1.__assign({ ref: innerRef, className: classnames(moduleClassName(), className) }, props), React.createElement(Icon_1.Icon, { type: type }));
};
exports.IconButton.propTypes = {
    TagName: PropTypes.string,
    type: PropTypes.oneOf(Icon_1.IconTypesArray).isRequired,
    className: PropTypes.string
};